import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardReadingPaneOption')(function discardReadingPaneOption(state) {
    var optionState = state.optionState;
    optionState.readingPanePosition = null;
    optionState.nextSelection = null;
    optionState.loadMessageOnLogOn = null;
}));
//# sourceMappingURL=discardReadingPaneOption.js.map